// Documents for September 2026 onwards carry the Europea Residences Group logo.
export const shouldUseNewLogo = (
  month?: number | string,
  year?: number | string
): boolean => {
  if (!month || !year) return false;

  // month can be number (1-12), numeric string ("10") or name ("October", "Oct")
  const monthIndex =
    typeof month === "string" && isNaN(Number(month))
      ? new Date(`${month} 1, 2000`).getMonth()
      : Number(month) - 1;

  if (isNaN(monthIndex) || isNaN(Number(year))) return false;

  const selectedDate = new Date(Number(year), monthIndex);
  const cutoffDate = new Date(2026, 8); // September 2026 (month is 0-based)

  return selectedDate >= cutoffDate;
};

export default shouldUseNewLogo;
